import { render, staticRenderFns } from "./CalendarEventComponent.vue?vue&type=template&id=2125b0da&scoped=true&"
import script from "./CalendarEventComponent.vue?vue&type=script&lang=js&"
export * from "./CalendarEventComponent.vue?vue&type=script&lang=js&"
import style0 from "./CalendarEventComponent.vue?vue&type=style&index=0&id=2125b0da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2125b0da",
  null
  
)

export default component.exports